import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";

import postulationReduce from "./slices/postulationSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["postulationState"],
};

const rootReducer = combineReducers({
  postulationState: postulationReduce,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});
